"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallControl = exports.VideoWrapper = exports.SlidingShelf = exports.Inputs = exports.ButtonsIcon = exports.InputsPlayer = void 0;
const tslib_1 = require("tslib");
exports.InputsPlayer = tslib_1.__importStar(require("./ui/components/ModularComponents/Inputs/Player/styles"));
exports.ButtonsIcon = tslib_1.__importStar(require("./ui/ui-lib/Buttons/Icon/styles"));
exports.Inputs = tslib_1.__importStar(require("./ui/ui-lib/Inputs/styles"));
exports.SlidingShelf = tslib_1.__importStar(require("./ui/ui-lib/SlidingShelf/styles"));
exports.VideoWrapper = tslib_1.__importStar(require("./ui/ui-lib/VideoWrapper/styles"));
exports.CallControl = tslib_1.__importStar(require("./ui/ui-lib/CallControl/callControlStyles"));
//# sourceMappingURL=styles.js.map